<template>
  <div>
    <div
      class="site-blocks-cover inner-page"
      style="background-image: url('images/background1.webp');"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-7 mx-auto align-self-center">
            <div class="gradient text-center">
              <h1>About Us</h1>
              <p>
                EasyPharma aims to fulfill the gap that conventional pharmacies
                can't bridge down. 24/7 availability, Wide product categories,
                large stock.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="site-section site-section-sm site-blocks-1 border-0 "
      data-aos="fade"
    >
      <div class="container">
        <div class="row justify-content-center">
          <div
            class="col-md-6 col-lg-4 d-lg-flex mb-4 mb-lg-0 pl-4 justify-content-center"
            data-aos="fade-up"
            style="width: 100px;"
            data-aos-delay=""
          >
            <div class="icon mr-4 align-self-start ">
              <span class="icon-truck text-primary"></span>
            </div>
            <div class="text" style="text-align:center;">
              <h2>Free Shipping</h2>
              <p>
                Order essential medicines & Get free shipping above INR 500 card
                value
              </p>
            </div>
          </div>
          <div
            class="col-md-6 col-lg-4 d-lg-flex mb-4 mb-lg-0 pl-4"
            data-aos="fade-up"
            style="width: 100px;"
            data-aos-delay="100"
          >
            <div class="icon mr-4 align-self-start">
              <span class="icon-refresh2 text-primary"></span>
            </div>
            <div class="text" style="text-align:center;">
              <h2>Free Returns</h2>
              <p>
                Free return policy of upto 15 days
              </p>
            </div>
          </div>
          <div
            class="col-md-6 col-lg-4 d-lg-flex mb-4 mb-lg-0 pl-4"
            data-aos="fade-up"
            style="width: 100px;"
            data-aos-delay="200"
          >
            <div class="icon mr-4 align-self-start">
              <span class="icon-help text-primary"></span>
            </div>
            <div class="text" style="text-align:center;">
              <h2>Customer Support</h2>
              <p>
                24/7 Customer support for your med queries!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="site-section bg-light custom-border-bottom" data-aos="fade">
      <div class="container">
        <div class="row justify-content-center mb-5">
          <div class="col-md-7 site-section-heading text-center pt-4">
            <h2>The Team</h2>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-6 col-lg-6 mb-5">
            <div class="block-38 text-center">
              <div class="block-38-img">
                <div class="block-38-header">
                  <img
                    src="../assets/about2.webp"
                    loading="lazy"
                    alt="Image placeholder"
                    class="mb-4"
                  />
                  <h3 class="block-38-heading h4">Debaditya Sen</h3>
                  <p class="block-38-subheading">Lead Backend Developer</p>
                </div>
                <div class="block-38-body">
                  <p>
                    A technology enthusiast having a never ending appetite to
                    learn about new technology, contribute to make it better and
                    more productive. Specialties
                    <br />• Back-end Development <br />• Project planning <br />
                    • Leading a team to accomplish any given task <br />•
                    Dedicated and perfectionist
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 mb-5">
            <div class="block-38 text-center">
              <div class="block-38-img">
                <div class="block-38-header">
                  <img
                    src="../assets/about3.webp"
                    loading="lazy"
                    alt="Image placeholder"
                    class="mb-4"
                  />
                  <h3 class="block-38-heading h4">Ritesh Bucha</h3>
                  <p class="block-38-subheading">Lead UI/UX Engineer</p>
                </div>
                <div class="block-38-body">
                  <p>
                    Things you would want to know about me :<br />
                    + Front-end developer & Tech enthusiast<br />
                    + Never ending appetite to learn and contribute towards the
                    society. <br />+ Dedicated towards work and a perfectionist.
                    <br />+ Project planning and Leading. <br />+ Runs for
                    effectiveness/efforts over Success.<br /><b><a href="https://bucharitesh.in/">www.bucharitesh.in</a></b>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 mb-5">
            <div class="block-38 text-center">
              <div class="block-38-img">
                <div class="block-38-header">
                  <img
                    src="../assets/about4.webp"
                    loading="lazy"
                    alt="Image placeholder"
                    class="mb-4"
                  />
                  <h3 class="block-38-heading h4">Rounak Roychowdhury</h3>
                  <p class="block-38-subheading">Product Manager</p>
                </div>
                <div class="block-38-body">
                  <p>
                    Undergraduate at SRM University, currently pursuing Computer
                    Science and Engineering (CSE).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.gradient {
  font-size: 72px;
  background: -webkit-linear-gradient(#4050a4, #9d12df, rgb(182, 15, 15));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
